/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Tipi di menu del servizio mensa. Tipi previsti:  -*ORDINARIO*  -*EXTRA*
 */
export enum ServizioMensaMenuType {

    ORDINARIO = 'ORDINARIO',

    EXTRA = 'EXTRA'
}

